import { render, staticRenderFns } from "./AppearanceTest.vue?vue&type=template&id=6b5d605b&scoped=true&"
import script from "./AppearanceTest.vue?vue&type=script&lang=js&"
export * from "./AppearanceTest.vue?vue&type=script&lang=js&"
import style0 from "./AppearanceTest.vue?vue&type=style&index=0&id=6b5d605b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d605b",
  null
  
)

export default component.exports